/**
 * Created by Yangxunwu on 2018/6/7.
 */

import Cookies from 'js-cookie'
import { getItem, setItem, deleteItem } from './storage'

const TokenKey = 'access_token'
const FinishRegisterKey = 'is-finish-register';
const UserTypeKey = 'userType';

export function getToken() {
	return Cookies.get(TokenKey)
}

export function setToken(token) {
	return Cookies.set(TokenKey, token)
}

export function removeToken() {
	return Cookies.remove(TokenKey)
}

export function getFinishRegister() {
	return  getItem(FinishRegisterKey)
}

export function setFinishRegister(value) {
	return setItem(FinishRegisterKey, !!value);
}

export function removeFinishRegister() {
	return deleteItem(FinishRegisterKey);
}

/**
 * 设置用户类型
 * @param value
 * @returns {*}
 */
export function setUserType(value) {
	return setItem(UserTypeKey, value);
}

/**
 * 查找用户类型
 * @returns {null}
 */
export function getUserType() {
	return getItem(UserTypeKey);
}


// WEBPACK FOOTER //
// ./src/utils/auth.js